import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useMessage } from '../contexts/MessageContext'
import { useApi } from '../utils/api'
import config from '../utils/config'

export default function Header() {
  const location = useLocation()
  const { logout } = useAuth()
  const { setMessage } = useMessage()
  const { fetchWithAuth } = useApi()

  const handleLogout = async () => {
    try {
      const response = await fetchWithAuth('/admin/logout', {
        method: 'POST'
      })

      if (!response.ok) {
        throw new Error('Logout failed')
      }

      logout()
      setMessage('Logged out successfully')
    } catch (error) {
      console.error('Logout error:', error)
      setMessage('Logout failed. Please try again.')
    }
  }

  const isEmailTemplatesActive = location.pathname.startsWith('/email-templates') || 
                                location.pathname.startsWith('/new-email-template') || 
                                location.pathname.startsWith('/edit-email-template');

  const isAdminUsersActive = location.pathname.startsWith('/admin-users') || 
                            location.pathname.startsWith('/new-admin-user') || 
                            location.pathname.startsWith('/edit-admin-user');

  const isContentGroupsActive = location.pathname.startsWith('/content-groups') || 
                               location.pathname.startsWith('/new-content-group') || 
                               location.pathname.startsWith('/edit-content-group');
                               
  const isEmailAnalyticsActive = location.pathname.startsWith('/email-analytics');

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <img
          src={`${config.assetsUrl}/static/images/header_logo@2x.png`}
          alt="Panagora Logo"
          className="h-10 w-auto"
        />
        <nav className="flex items-center space-x-8">
          <Link 
            to="/email-templates" 
            className={`uppercase text-base font-bold ${isEmailTemplatesActive ? 'text-panagora-teal' : 'text-panagora-slate-gray'}`}
          >
            EMAIL TEMPLATES
          </Link>
          <Link 
            to="/content-groups" 
            className={`uppercase text-base font-bold ${isContentGroupsActive ? 'text-panagora-teal' : 'text-panagora-slate-gray'}`}
          >
            CONTENT GROUPS
          </Link>
          <Link 
            to="/email-analytics" 
            className={`uppercase text-base font-bold ${isEmailAnalyticsActive ? 'text-panagora-teal' : 'text-panagora-slate-gray'}`}
          >
            EMAIL ANALYTICS
          </Link>
          <Link 
            to="/admin-users" 
            className={`uppercase text-base font-bold ${isAdminUsersActive ? 'text-panagora-teal' : 'text-panagora-slate-gray'}`}
          >
            ADMIN USERS
          </Link>
          <button
            className="text-panagora-slate-gray hover:text-panagora-teal uppercase text-base font-bold"
            onClick={handleLogout}
          >
            LOGOUT
          </button>
        </nav>
      </div>
    </header>
  )
}
